// Texty výpisu značiek — slovenské dvojče locale/cs/brandsPage.js.
import { plural } from '../plural.js';

export default {
  perex:
    'Predávame len značky, ktoré si sami vyskúšame a vieme opraviť, takže na náhradné diely a servis dosiahnete aj po rokoch. Pri každej značke nájdete celý jej sortiment na sklade.',
  filterPlaceholder: 'Filtrovať značky',
  filterNone: 'Žiadna značka tomuto názvu nezodpovedá.',
  ownEyebrow: 'Vlastná značka',
  ownTitle: 'Jipos Tools – náradie, ktoré máme pod rukami',
  ownText:
    'Vyvíjame a dovážame ju sami, takže poznáme každý diel. Náhradné diely držíme skladom a servis beží na našej predajni v Bíline.',
  ownCtaPre: 'Zobraziť produkty ',
  seoTitle: 'Prečo u nás nájdete práve tieto značky',
  seoText:
    'Sortiment staviame okolo strojov, ktoré vieme sami opraviť. Každú značku držíme dlhodobo, nie v jednej sezónnej vlne. Vďaka tomu na náhradné diely dosiahnete aj o pár rokov a servis nemusí čakať na dovoz.',
  seoPoints: [
    { title: 'Servis na predajni', text: 'opravy a údržbu riešime v Bíline, nie cez centrálu dodávateľa.' },
    { title: 'Náhradné diely skladom', text: 'pri hlavných značkách držíme diely na bežné opotrebenie.' },
    { title: 'Vyskúšané v prevádzke', text: 'stroje si na predajni vyskúšate naživo, poradíme podľa reálneho použitia.' },
  ],
  adviceTitle: 'Hľadáte konkrétny model?',
  adviceText: 'Povedzte nám značku a typ. Overíme dostupnosť aj náhradné diely, aj keď stroj nie je vo výpise.',
  adviceAction: 'Napísať poradni',
  /** 1 značka / 2–4 značky / 5+ značiek */
  brandsWord: (n) => plural(n, ['značka', 'značky', 'značiek']),
};
